module.exports = __webpack_public_path__ + "img/pic_5_zh.eb72f63f.png";